// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AccordionScrollController from "./accordion_scroll_controller";
application.register("accordion-scroll", AccordionScrollController);

import ArticleAppointmentController from "./article_appointment_controller";
application.register("article-appointment", ArticleAppointmentController);

import AiEmbeddingStatusController from "./ai_embedding_status_controller";
application.register("ai-embedding-status", AiEmbeddingStatusController);

import EmbeddingStartMarkerController from "./embedding_start_marker_controller";
application.register("embedding-start-marker", EmbeddingStartMarkerController);

import AiPromptDocumentController from "./ai_prompt_document_controller";
application.register("ai-prompt-document", AiPromptDocumentController);

import AiPromptDocumentStatusController from "./ai_prompt_document_status_controller";
application.register(
  "ai-prompt-document-status",
  AiPromptDocumentStatusController,
);

import AiWebSourceStatusController from "./ai_web_source_status_controller";
application.register("ai-web-source-status", AiWebSourceStatusController);

import Administration__Activitystream__CloseActivityReplyMonthController from "./administration/activitystream/close_activity_reply_month_controller";
application.register(
  "administration--activitystream--close-activity-reply-month",
  Administration__Activitystream__CloseActivityReplyMonthController,
);

import Administration__ContactTypesListController from "./administration/contact_types_list_controller";
application.register(
  "administration--contact-types-list",
  Administration__ContactTypesListController,
);

import Administration__EditCategoriesController from "./administration/edit_categories_controller";
application.register(
  "administration--edit-categories",
  Administration__EditCategoriesController,
);

import Administration__Groups__JoinRequestMessageController from "./administration/groups/join_request_message_controller";
application.register(
  "administration--groups--join-request-message",
  Administration__Groups__JoinRequestMessageController,
);

import Administration__Invites__SendBatchActionsController from "./administration/invites/send_batch_actions_controller";
application.register(
  "administration--invites--send-batch-actions",
  Administration__Invites__SendBatchActionsController,
);

import Administration__Invites__SentController from "./administration/invites/sent_controller";
application.register(
  "administration--invites--sent",
  Administration__Invites__SentController,
);

import Administration__Invites__ToggleBatchActionsController from "./administration/invites/toggle_batch_actions_controller";
application.register(
  "administration--invites--toggle-batch-actions",
  Administration__Invites__ToggleBatchActionsController,
);

import Administration__JoinRequests__TableController from "./administration/join_requests/table_controller";
application.register(
  "administration--join-requests--table",
  Administration__JoinRequests__TableController,
);

import Administration__Newsletter__DragAndDropController from "./administration/newsletter/drag_and_drop_controller";
application.register(
  "administration--newsletter--drag-and-drop",
  Administration__Newsletter__DragAndDropController,
);

import Administration__Newsletter__IntervalController from "./administration/newsletter/interval_controller";
application.register(
  "administration--newsletter--interval",
  Administration__Newsletter__IntervalController,
);

import Administration__UnlayerFormController from "./administration/unlayer_form_controller";
application.register(
  "administration--unlayer-form",
  Administration__UnlayerFormController,
);

import Administration__ProfileChangeRequests__SendBatchActionsController from "./administration/profile_change_requests/send_batch_actions_controller";
application.register(
  "administration--profile-change-requests--send-batch-actions",
  Administration__ProfileChangeRequests__SendBatchActionsController,
);

import Administration__ProfileChangeRequests__ToggleBatchActionsController from "./administration/profile_change_requests/toggle_batch_actions_controller";
application.register(
  "administration--profile-change-requests--toggle-batch-actions",
  Administration__ProfileChangeRequests__ToggleBatchActionsController,
);

import Administration__RoleAssignments__SortableTableController from "./administration/role_assignments/sortable_table_controller";
application.register(
  "administration--role-assignments--sortable-table",
  Administration__RoleAssignments__SortableTableController,
);

import Administration__RoleAssignmentsController from "./administration/role_assignments_controller";
application.register(
  "administration--role-assignments",
  Administration__RoleAssignmentsController,
);

import Administration__TableauFilterController from "./administration/tableau_filter_controller";
application.register(
  "administration--tableau-filter",
  Administration__TableauFilterController,
);

import Administration__Teams__FallbackUpnAssignmentsController from "./administration/teams/fallback_upn_assignments_controller";
application.register(
  "administration--teams--fallback-upn-assignments",
  Administration__Teams__FallbackUpnAssignmentsController,
);

import AltchaController from "./altcha_controller";
application.register("altcha", AltchaController);

import AssignChannelSubscriptionsFormController from "./assign_channel_subscriptions_form_controller";
application.register(
  "assign-channel-subscriptions-form",
  AssignChannelSubscriptionsFormController,
);

import AuditLog__FilterController from "./audit_log/filter_controller";
application.register("audit-log--filter", AuditLog__FilterController);

import AutoAssignmentFormController from "./auto_assignment_form_controller";
application.register("auto-assignment-form", AutoAssignmentFormController);

import ChannelStartPagesController from "./channel_start_pages_controller";
application.register("channel-start-pages-form", ChannelStartPagesController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import NetworkFocusLabelsFormController from "./network_focus_labels_form_controller";

import EmailTwoFactorController from "./email_two_factor_controller";
application.register("email-two-factor", EmailTwoFactorController);

import EmbeddingGroupPickerController from "./embedding_group_picker_controller";
application.register("embedding-group-picker", EmbeddingGroupPickerController);

import ExternalActivitystreamController from "./external_activitystream_controller";
application.register(
  "external-activitystream",
  ExternalActivitystreamController,
);

import FlashController from "./flash_controller";
application.register("flash", FlashController);
application.register(
  "network-focus-labels-form",
  NetworkFocusLabelsFormController,
);

import File__ValidateFileExtensionFilterListController from "./file/validate_file_extension_filter_list_controller";
application.register(
  "file--validate-file-extension-filter-list",
  File__ValidateFileExtensionFilterListController,
);

import Integrations__TableauEmbeddingController from "./integrations/tableau_embedding_controller";
application.register(
  "integrations--tableau-embedding",
  Integrations__TableauEmbeddingController,
);

import Invites__HandleExternalInviteController from "./invites/handle_external_invite_controller";
application.register(
  "invites--handle-external-invite",
  Invites__HandleExternalInviteController,
);

import MinistryController from "./ministry_controller";
application.register("ministry", MinistryController);

import PermissionPickerController from "./permission_picker_controller";
application.register("permission-picker", PermissionPickerController);

import Shared__AppNewItemController from "./shared/app_new_item_controller";
application.register("shared--app-new-item", Shared__AppNewItemController);

import Shared__AutosubmitController from "./shared/autosubmit_controller";
application.register("shared--autosubmit", Shared__AutosubmitController);

import Shared__DropdownSheetController from "./shared/dropdown_sheet_controller";
application.register("shared--dropdown-sheet", Shared__DropdownSheetController);

import Shared__GoBackButtonController from "./shared/go_back_button_controller";
application.register("shared--go-back-button", Shared__GoBackButtonController);

import Shared__LegalCheckboxesController from "./shared/legal_checkboxes_controller";
application.register(
  "shared--legal-checkboxes",
  Shared__LegalCheckboxesController,
);

import Shared__OmitBlankParamsController from "./shared/omit_blank_params_controller";
application.register(
  "shared--omit-blank-params",
  Shared__OmitBlankParamsController,
);

import Shared__PasswordToggleController from "./shared/password_toggle_controller";
application.register(
  "shared--password-toggle",
  Shared__PasswordToggleController,
);

import Shared__PropertySetEditController from "./shared/property_set_edit_controller";
application.register(
  "shared--property-set-edit",
  Shared__PropertySetEditController,
);

import Shared__RevealController from "./shared/reveal_controller";
application.register("shared--reveal", Shared__RevealController);

import Shared__SelectAllController from "./shared/select_all_controller";
application.register("shared--select-all", Shared__SelectAllController);

import Shared__ServerSortableTableController from "./shared/server_sortable_table_controller";
application.register(
  "shared--server-sortable-table",
  Shared__ServerSortableTableController,
);

import Shared__SortableTableController from "./shared/sortable_table_controller";
application.register("shared--sortable-table", Shared__SortableTableController);

import Shared__SubmitOnChangeController from "./shared/submit_on_change_controller";
application.register(
  "shared--submit-on-change",
  Shared__SubmitOnChangeController,
);

import Shared__TabbarController from "./shared/tabbar_controller";
application.register("shared--tabbar", Shared__TabbarController);

import Shared__TabSheetController from "./shared/tab_sheet_controller";
application.register("shared--tab-sheet", Shared__TabSheetController);

import Shared__TimeagoController from "./shared/timeago_controller";
application.register("shared--timeago", Shared__TimeagoController);

import Shared__ToggleController from "./shared/toggle_controller";
application.register("shared--toggle", Shared__ToggleController);

import Shared__TooltipInitController from "./shared/tooltip_init_controller";
application.register("shared--tooltip-init", Shared__TooltipInitController);

import Shared__TranslationDropdownController from "./shared/translation_dropdown_controller";
application.register(
  "shared--translation-dropdown",
  Shared__TranslationDropdownController,
);

import TwoFactorAuthenticationsController from "./two_factor_authentications_controller";
application.register(
  "two-factor-authentications",
  TwoFactorAuthenticationsController,
);

import PersonalAccessTokensController from "./personal_access_tokens_controller";
application.register("personal-access-tokens", PersonalAccessTokensController);
